import React, { useMemo } from "react";
import styles from "./index.module.scss";
import OnboardingItem from "./onboarding-progress.helpers";
import { onboardingItems } from "./mock.data";


interface OnboardingProgressProps {
  progressPercentage: number;
}

const OnboardingProgress = ({ progressPercentage }: OnboardingProgressProps) => {
  const getProgressColorClass = (percentage: number) => {
    if (percentage >= 0 && percentage <= 33) {
      return styles.progressBarRed;
    } else if (percentage >= 34 && percentage <= 66) {
      return styles.progressBarYellow;
    } else {
      return styles.progressBarGreen;
    }
  };

  const progressColorClass = useMemo(() => getProgressColorClass(progressPercentage), [progressPercentage]);

  const progressBarWidth = `${progressPercentage}%`;

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <div className={styles.headerContent}>
          <div className={styles.titleRow}>
            <div className={styles.title}>Onboarding Progress</div>
          </div>
        </div>

        <div className={styles.progressSection}>
          <div className={styles.progressHeader}>
            <div className={styles.progressLabel} />

            <div className={styles.progressPercentage}>
              <div className={styles.percentageText}>{progressPercentage}%</div>
            </div>
          </div>

          <div className={styles.progressBarContainer}>
            <div 
              className={`${styles.progressBar} ${progressColorClass}`}
              style={{ width: progressBarWidth }}
            />
          </div>
        </div>
      </div>

      <div className={styles.itemsContainer}>
        {onboardingItems.map((item) => <OnboardingItem key={item.id} item={item} isChild={false} />)}
      </div>
    </div>
  );
};

export default OnboardingProgress;